var _circle, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _g36, _g37, _g38, _g39, _g40, _g41, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYellowMask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 595,
    height: 595,
    viewBox: "0 0 595 595",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 297.021,
    cy: 297.02,
    r: 297,
    fill: "#001FEA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_di_2489_89754)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M210.521 12.8121L210.521 35.0496L240.104 5.46706C245.348 4.44921 250.642 3.56934 255.981 2.83138L287.521 34.372L287.521 0.16792C289.516 0.105228 291.517 0.0622133 293.521 0.0390625V35.0454L327.049 1.518C330.845 1.89911 334.619 2.35169 338.372 2.87438L370.521 35.024L370.521 9.18368C372.53 9.69494 374.53 10.2267 376.521 10.7786L376.521 34.8929L394.892 16.5222C396.98 17.2507 399.058 18.0018 401.124 18.7754L380.622 39.2771H412.021V23.1032C414.033 23.9486 416.033 24.8156 418.021 25.7038V39.2771L444.697 39.2771C460.159 48.1555 474.747 58.3852 488.298 69.8051L495.021 76.5282L495.021 75.6443C499.042 79.243 502.964 82.9496 506.783 86.7595L505.253 86.7595L524.235 105.742C532.753 115.85 540.609 126.534 547.736 137.728L542.521 132.513V163.775H562.527C563.527 165.762 564.504 167.763 565.46 169.775H542.521V201.056L568.096 175.481C568.975 177.44 569.834 179.409 570.672 181.39L546.78 205.283H578.021L578.021 200.603C580.242 207.075 582.244 213.648 584.021 220.314V242.556L588.228 238.349C588.703 240.721 589.15 243.103 589.568 245.494L588.28 246.783H589.79C590.13 248.776 590.45 250.776 590.749 252.783H588.28L591.166 255.668C591.613 258.876 592.008 262.1 592.352 265.34L584.021 257.009V288.282H593.895C593.953 290.278 593.991 292.278 594.009 294.282H584.021V325.556L593.414 316.163C593.218 319.247 592.975 322.319 592.685 325.377L588.28 329.782H592.235C592.015 331.789 591.774 333.789 591.515 335.782H588.932L591.209 338.059C590.868 340.526 590.497 342.984 590.095 345.431L584.021 339.357V371.263H584.666C582.733 378.773 580.514 386.167 578.021 393.435L578.021 377.263H546.75L573.98 404.492C573.191 406.522 572.382 408.541 571.55 410.548L542.521 381.519V412.763H570.623C569.771 414.775 568.897 416.775 568.003 418.763H542.521V450.042L562.756 429.807C559.566 436.179 556.153 442.42 552.528 448.52L546.767 454.281H549.016C545.077 460.58 540.908 466.72 536.521 472.691L536.521 464.527L505.258 495.791L517.703 495.791C515.877 497.816 514.024 499.816 512.144 501.791L505.01 501.791L508.634 505.415C507.231 506.84 505.813 508.251 504.381 509.648L501.021 506.288L501.021 512.874C499.047 514.741 497.047 516.581 495.021 518.393L495.021 506.027L463.758 537.291H471.638C465.758 541.571 459.716 545.64 453.521 549.488V547.527L448.523 552.526C442.423 556.151 436.181 559.563 429.81 562.753L449.272 543.291H418.021L418.021 568.334C416.033 569.222 414.033 570.089 412.021 570.935L412.021 543.291H380.778L409.477 571.99C407.463 572.815 405.437 573.618 403.401 574.399L376.521 547.519L376.521 578.791L391.157 578.791C384.384 581.052 377.502 583.077 370.521 584.854V584.791H339.278L344.699 590.212C342.247 590.608 339.784 590.974 337.311 591.309L335.021 589.019L335.021 591.611C333.027 591.865 331.027 592.1 329.021 592.315V589.041L325.38 592.682C322.321 592.972 319.25 593.216 316.165 593.412L324.786 584.791L293.521 584.791V593.999C291.517 593.975 289.516 593.932 287.521 593.87V584.791H256.292L263.668 592.167C260.406 591.802 257.16 591.385 253.932 590.916L252.021 589.006V590.632C250.015 590.327 248.015 590.002 246.021 589.657V589.041L245.497 589.565C243.105 589.147 240.723 588.7 238.352 588.225L241.786 584.791H223.273C216.378 583.029 209.579 581.026 202.886 578.791L204.521 578.791V547.541L181.393 570.669C179.412 569.831 177.442 568.973 175.484 568.093L200.286 543.291H169.021V565.097C167.009 564.134 165.009 563.15 163.021 562.143V543.291H130.958C127.768 541.135 124.622 538.919 121.521 536.645V501.791H86.0214V506.036C82.7146 502.698 79.4865 499.282 76.3401 495.791H80.0214V460.281H48.88C45.2456 454.768 41.79 449.127 38.5214 443.366V418.763H26.04C25.1453 416.775 24.2718 414.775 23.4198 412.763H38.5214V381.378L18.7779 401.122C18.0043 399.055 17.2532 396.978 16.5247 394.89L34.1513 377.263H10.9884C10.4308 375.271 9.89349 373.271 9.37664 371.263H34.2788L3.1244 340.109C2.49587 335.784 1.96053 331.429 1.52049 327.046L34.2843 294.282L0.0336914 294.282C0.0517851 292.278 0.0897423 290.278 0.147376 288.282L34.2846 288.282L2.73107 256.729C3.48968 251.135 4.40401 245.591 5.46955 240.101L34.2884 211.283H12.5836C13.1884 209.273 13.8138 207.273 14.4597 205.283L34.2845 205.283L19.6409 190.639C20.4223 188.603 21.2255 186.577 22.0502 184.563L38.5214 201.034L38.5214 169.775L28.5826 169.775C29.5383 167.763 30.5159 165.762 31.5152 163.775L38.5214 163.775V150.672C40.4564 147.261 42.457 143.892 44.5214 140.568V163.775H75.7772L47.646 135.644C48.7567 133.931 49.8846 132.23 51.0294 130.542L80.0214 159.534L80.0214 128.26H52.5927C53.9888 126.241 55.4093 124.241 56.8536 122.26H80.0214L80.0214 94.2366C84.3533 89.6029 88.8319 85.1081 93.4497 80.7595L121.521 80.7595V57.3928C123.503 55.9391 125.503 54.5094 127.521 53.1042V80.7595L158.997 80.7595L129.783 51.5453C131.466 50.396 133.162 49.2636 134.871 48.1482L163.021 76.2989L163.021 45.2771H139.356C142.643 43.2139 145.973 41.2134 149.346 39.2771H163.021V31.8944C165.009 30.888 167.009 29.9033 169.021 28.9405L169.021 39.2771L200.279 39.2771L183.492 22.4898C185.499 21.6586 187.518 20.8487 189.548 20.0606L204.521 35.0341L204.521 14.7061C206.512 14.0543 208.512 13.4228 210.521 12.8121ZM370.521 578.791V547.541L339.271 578.791H370.521ZM324.793 578.791L293.521 547.519L293.521 578.791L324.793 578.791ZM287.521 578.791V547.541L256.271 578.791H287.521ZM241.806 578.791L210.521 547.506V578.791H241.806ZM38.5214 284.034L7.26985 252.783H38.5214V284.034ZM7.27376 246.783H38.5214V215.535L7.27376 246.783ZM44.5214 284.045V252.783H75.7842L44.5214 284.045ZM44.5214 246.783H75.7845L44.5214 215.519V246.783ZM121.521 284.034L90.2698 252.783H121.521V284.034ZM90.2695 246.783H121.521V215.531L90.2695 246.783ZM127.521 283.893V252.783H158.632L127.521 283.893ZM127.521 246.783H158.785L127.521 215.519V246.783ZM204.521 284.034L173.27 252.783L204.521 252.783L204.521 284.034ZM173.117 246.783L204.521 246.783V215.378L173.117 246.783ZM210.521 284.555L210.521 252.783H242.294L210.521 284.555ZM210.521 246.783H241.516L210.521 215.788V246.783ZM287.521 284.303L256.001 252.783L287.521 252.783V284.303ZM256.779 246.783L287.521 246.783V216.04L256.779 246.783ZM293.521 284.315L293.521 252.783L325.054 252.783L293.521 284.315ZM293.521 246.783L325.02 246.783L293.521 215.284L293.521 246.783ZM370.521 283.799L339.505 252.783H370.521V283.799ZM339.539 246.783H370.521V215.8L339.539 246.783ZM376.521 283.735L376.521 252.783L407.474 252.783L376.521 283.735ZM376.521 246.783L407.784 246.783L376.521 215.519L376.521 246.783ZM453.521 284.034L422.27 252.783L453.521 252.783L453.521 284.034ZM421.959 246.783L453.521 246.783L453.521 215.22L421.959 246.783ZM459.521 284.056V252.783H490.794L459.521 284.056ZM459.521 246.783H491.447L459.521 214.857V246.783ZM536.521 283.372L505.932 252.783H536.521L536.521 283.372ZM505.28 246.783H536.521L536.521 215.541L505.28 246.783ZM542.521 284.056V252.783H573.794L542.521 284.056ZM542.521 246.783H573.795L542.521 215.509V246.783ZM449.293 537.291L418.021 506.019L418.021 537.291H449.293ZM412.021 537.291L412.021 506.041L380.771 537.291H412.021ZM366.293 537.291L335.021 506.019L335.021 537.291L366.293 537.291ZM335.021 543.291L366.286 543.291L335.021 574.555L335.021 543.291ZM329.021 537.291L329.021 506.041L297.771 537.291H329.021ZM297.778 543.291H329.021V574.534L297.778 543.291ZM283.293 537.291L252.021 506.019V537.291L283.293 537.291ZM252.021 543.291L283.286 543.291L252.021 574.555V543.291ZM246.021 537.291V506.041L214.771 537.291H246.021ZM214.792 543.291H246.021V574.52L214.792 543.291ZM200.306 537.291L169.021 506.006V537.291H200.306ZM163.021 537.291V505.72L131.451 537.291H163.021ZM80.0214 242.534L48.7698 211.283H80.0214V242.534ZM48.7738 205.283H80.0214V174.035L48.7738 205.283ZM86.0214 242.545V211.283H117.284L86.0214 242.545ZM86.0214 205.283H117.285L86.0214 174.019V205.283ZM163.021 242.534L131.77 211.283H163.021V242.534ZM131.77 205.283H163.021V174.031L131.77 205.283ZM169.021 242.393V211.283H200.132L169.021 242.393ZM169.021 205.283H200.016L169.021 174.288V205.283ZM246.021 242.803L214.501 211.283H246.021V242.803ZM214.617 205.283H246.021V173.878L214.617 205.283ZM252.021 243.055V211.283L283.794 211.283L252.021 243.055ZM252.021 205.283L283.52 205.283L252.021 173.784V205.283ZM329.021 242.299L298.005 211.283H329.021V242.299ZM298.279 205.283H329.021V174.54L298.279 205.283ZM335.021 242.815L335.021 211.283L366.554 211.283L335.021 242.815ZM335.021 205.283L366.285 205.283L335.021 174.019L335.021 205.283ZM412.021 242.534L380.77 211.283H412.021V242.534ZM381.039 205.283H412.021V174.3L381.039 205.283ZM418.021 242.235L418.021 211.283L448.974 211.283L418.021 242.235ZM418.021 205.283L449.947 205.283L418.021 173.357L418.021 205.283ZM495.021 241.872L464.432 211.283H495.021L495.021 241.872ZM463.459 205.283H495.021L495.021 173.72L463.459 205.283ZM501.021 242.556V211.283H532.294L501.021 242.556ZM501.021 205.283H532.295L501.021 174.009V205.283ZM578.021 242.524L546.78 211.283H578.021L578.021 242.524ZM490.524 495.791L459.521 464.788V495.791H490.524ZM459.521 501.791H490.772L459.521 533.042L459.521 501.791ZM453.521 495.791V464.541L422.271 495.791H453.521ZM422.278 501.791H453.521L453.521 533.034L422.278 501.791ZM407.793 495.791L376.521 464.519L376.521 495.791L407.793 495.791ZM376.521 501.791L407.786 501.791L376.521 533.055L376.521 501.791ZM370.521 495.791V464.541L339.271 495.791H370.521ZM339.278 501.791H370.521L370.521 533.034L339.278 501.791ZM324.793 495.791L293.521 464.519L293.521 495.791L324.793 495.791ZM293.521 501.791L324.786 501.791L293.521 533.055L293.521 501.791ZM287.521 495.791V464.541L256.271 495.791H287.521ZM256.278 501.791H287.521L287.521 533.034L256.278 501.791ZM241.793 495.791L210.521 464.519V495.791H241.793ZM210.521 501.791H241.786L210.521 533.055V501.791ZM204.521 495.791V464.22L172.951 495.791H204.521ZM173.292 501.791H204.521V533.02L173.292 501.791ZM158.807 495.791L127.521 464.506V495.791H158.807ZM127.521 501.791H158.465L127.521 532.735V501.791ZM121.521 495.791V464.8L90.5307 495.791H121.521ZM44.5214 201.05L44.5214 169.775H75.7958L44.5214 201.05ZM121.521 201.034L90.2624 169.775H121.521V201.034ZM90.2811 163.775H121.521V132.535L90.2811 163.775ZM127.521 201.045V169.775L158.792 169.775L127.521 201.045ZM127.521 163.775L158.509 163.775L127.521 132.788V163.775ZM204.521 201.303L172.994 169.775H204.521V201.303ZM173.277 163.775H204.521V132.531L173.277 163.775ZM210.521 200.893V169.775H241.639L210.521 200.893ZM210.521 163.775H242.012L210.521 132.284V163.775ZM287.521 200.799L256.498 169.775H287.521L287.521 200.799ZM256.124 163.775H287.521L287.521 132.378L256.124 163.775ZM293.521 201.555L293.521 169.775H325.301L293.521 201.555ZM293.521 163.775H324.777L293.521 132.519L293.521 163.775ZM370.521 201.034L339.262 169.775L370.521 169.775L370.521 201.034ZM339.787 163.775L370.521 163.775L370.521 133.04L339.787 163.775ZM376.521 201.315L376.521 169.775H408.061L376.521 201.315ZM376.521 163.775H408.439L376.521 131.857L376.521 163.775ZM453.521 200.372L422.924 169.775L453.521 169.775L453.521 200.372ZM422.546 163.775L453.521 163.775L453.521 132.8L422.546 163.775ZM459.521 200.735V169.775H490.481L459.521 200.735ZM459.521 163.775H490.787L459.521 132.509V163.775ZM536.521 201.024L505.273 169.775H536.521L536.521 201.024ZM504.966 163.775H536.521L536.521 132.22L504.966 163.775ZM532.518 454.281L501.021 422.784V454.281L532.518 454.281ZM501.021 460.281L532.282 460.281L501.021 491.542V460.281ZM495.021 454.281V423.041L463.781 454.281H495.021ZM463.5 460.281H495.021V491.802L463.5 460.281ZM449.015 454.281L418.021 423.288L418.021 454.281H449.015ZM418.021 460.281H449.296L418.021 491.555L418.021 460.281ZM412.021 454.281V423.041L380.781 454.281H412.021ZM380.768 460.281H412.021L412.021 491.534L380.768 460.281ZM366.283 454.281L335.021 423.019L335.021 454.281L366.283 454.281ZM335.021 460.281L366.296 460.281L335.021 491.555L335.021 460.281ZM329.021 454.281V423.041L297.781 454.281H329.021ZM297.768 460.281H329.021L329.021 491.534L297.768 460.281ZM283.283 454.281L252.021 423.019V454.281L283.283 454.281ZM252.021 460.281L283.296 460.281L252.021 491.555V460.281ZM246.021 454.281V422.72L214.46 454.281H246.021ZM214.768 460.281H246.021V491.534L214.768 460.281ZM200.283 454.281L169.021 423.019V454.281H200.283ZM169.021 460.281H199.975L169.021 491.235V460.281ZM163.021 454.281V423.3L132.04 454.281H163.021ZM131.782 460.281H163.021V491.52L131.782 460.281ZM117.297 454.281L86.0214 423.006V454.281H117.297ZM86.0214 460.281H117.555L86.0214 491.815V460.281ZM80.0214 454.281V423.54L49.2807 454.281H80.0214ZM86.0214 159.55V128.26H117.311L86.0214 159.55ZM86.0214 122.26H116.993L86.0214 91.2878V122.26ZM163.021 159.803L131.478 128.26H163.021L163.021 159.803ZM131.797 122.26H163.021V91.0349L131.797 122.26ZM169.021 159.545V128.26H200.307L169.021 159.545ZM169.021 122.26H200.497L169.021 90.7841V122.26ZM246.021 159.299L214.982 128.26H246.021V159.299ZM214.793 122.26H246.021V91.0307L214.793 122.26ZM252.021 159.393L252.021 128.26L283.155 128.26L252.021 159.393ZM252.021 122.26H283.262L252.021 91.0194V122.26ZM329.021 159.534L297.747 128.26L329.021 128.26L329.021 159.534ZM297.64 122.26H329.021L329.021 90.8782L297.64 122.26ZM335.021 160.055L335.021 128.26H366.817L335.021 160.055ZM335.021 122.26H366.924L335.021 90.3573V122.26ZM412.021 158.872L381.409 128.26L412.021 128.26L412.021 158.872ZM381.302 122.26L412.021 122.26L412.021 91.5403L381.302 122.26ZM418.021 159.815L418.021 128.26H449.577L418.021 159.815ZM418.021 122.26H449.272L418.021 91.0092L418.021 122.26ZM495.021 159.524L463.757 128.26H495.021V159.524ZM464.062 122.26H495.021L495.021 91.3001L464.062 122.26ZM501.021 159.235V128.26H531.997L501.021 159.235ZM501.021 122.26H532.267L501.021 91.0135V122.26ZM536.521 412.763L536.521 381.541L505.299 412.763L536.521 412.763ZM505.486 418.763L536.521 418.763V449.799L505.486 418.763ZM491.001 412.763L459.521 381.284V412.763H491.001ZM459.521 418.763H490.813L459.521 450.055V418.763ZM453.521 412.763L453.521 381.541L422.299 412.763H453.521ZM421.982 418.763L453.521 418.763V450.302L421.982 418.763ZM407.497 412.763L376.521 381.788L376.521 412.763H407.497ZM376.521 418.763H407.813L376.521 450.055L376.521 418.763ZM370.521 412.763V381.541L339.299 412.763H370.521ZM339.251 418.763L370.521 418.763L370.521 450.034L339.251 418.763ZM324.765 412.763L293.521 381.519L293.521 412.763H324.765ZM293.521 418.763H324.813L293.521 450.055L293.521 418.763ZM287.521 412.763L287.521 381.22L255.978 412.763H287.521ZM256.251 418.763H287.521L287.521 450.034L256.251 418.763ZM241.765 412.763L210.521 381.519V412.763H241.765ZM210.521 418.763H241.493L210.521 449.735V418.763ZM204.521 412.763V381.8L173.558 412.763H204.521ZM173.251 418.763L204.521 418.763V450.034L173.251 418.763ZM158.765 412.763L127.521 381.519L127.521 412.763L158.765 412.763ZM127.521 418.763L159.073 418.763L127.521 450.315V418.763ZM121.521 412.763L121.521 382.04L90.7983 412.763H121.521ZM90.2644 418.763H121.521V450.02L90.2644 418.763ZM75.7792 412.763L44.5214 381.506V412.763H75.7792ZM44.5214 418.763H76.313L44.5214 450.555L44.5214 418.763ZM121.521 118.303L89.9784 86.7595L121.521 86.7595L121.521 118.303ZM127.521 118.05V86.7595L158.811 86.7595L127.521 118.05ZM204.521 117.799L173.482 86.7595H204.521L204.521 117.799ZM173.297 80.7595H204.521V49.5349L173.297 80.7595ZM210.521 118.045V86.7595H241.807L210.521 118.045ZM210.521 80.7595H241.761L210.521 49.5194V80.7595ZM287.521 118.034L256.247 86.7595L287.521 86.7595L287.521 118.034ZM256.293 80.7595L287.521 80.7595L287.521 49.5307L256.293 80.7595ZM293.521 117.893L293.521 86.7595H324.655L293.521 117.893ZM293.521 80.7595H325.424L293.521 48.8573V80.7595ZM370.521 117.372L339.909 86.7595H370.521L370.521 117.372ZM339.14 80.7595H370.521L370.521 49.3782L339.14 80.7595ZM376.521 118.555L376.521 86.7595L408.317 86.7595L376.521 118.555ZM376.521 80.7595L407.772 80.7595L376.521 49.5092L376.521 80.7595ZM453.521 118.024L422.257 86.7595H453.521V118.024ZM422.802 80.7595L453.521 80.7595L453.521 50.0404L422.802 80.7595ZM459.521 118.315V86.7595H491.077L459.521 118.315ZM459.521 80.7595H490.767L459.521 49.5135V80.7595ZM48.764 377.263L80.0214 408.52L80.0214 377.263H48.764ZM86.0214 377.263L86.0214 409.055L117.813 377.263L86.0214 377.263ZM117.265 371.263L86.0214 371.263V340.019L117.265 371.263ZM131.75 377.263L163.021 408.534V377.263L131.75 377.263ZM163.021 371.263L132.299 371.263L163.021 340.54V371.263ZM169.021 377.263V408.815L200.573 377.263H169.021ZM200.265 371.263H169.021V340.019L200.265 371.263ZM214.75 377.263L246.021 408.534V377.263H214.75ZM246.021 371.263H215.058L246.021 340.3V371.263ZM252.021 377.263V408.235L282.993 377.263H252.021ZM283.265 371.263L252.021 371.263V340.019L283.265 371.263ZM297.75 377.263L329.021 408.534V377.263L297.75 377.263ZM329.021 371.263L297.478 371.263L329.021 339.72L329.021 371.263ZM335.021 377.263L335.021 408.555L366.314 377.263L335.021 377.263ZM365.997 371.263L335.021 371.263L335.021 340.288L365.997 371.263ZM380.482 377.263L412.021 408.803L412.021 377.263H380.482ZM412.021 371.263L380.799 371.263L412.021 340.041L412.021 371.263ZM418.021 377.263L418.021 408.555L449.314 377.263L418.021 377.263ZM449.5 371.263L418.021 371.263L418.021 339.784L449.5 371.263ZM463.985 377.263L495.021 408.299V377.263H463.985ZM495.021 371.263H463.799L495.021 340.041L495.021 371.263ZM501.021 377.263V408.555L532.314 377.263L501.021 377.263ZM532.265 371.263L501.021 371.263V340.019L532.265 371.263ZM578.021 371.263H546.799L578.021 340.041L578.021 371.263ZM80.0214 371.263H48.6366L80.0214 339.878V371.263ZM200.294 45.2771L169.021 45.2771V76.5496L200.294 45.2771ZM246.021 76.5341L214.764 45.2771H246.021L246.021 76.5341ZM214.779 39.2771H246.021V8.03492L214.779 39.2771ZM252.021 76.5454V45.2771H283.29L252.021 76.5454ZM252.021 39.2771H283.941L252.021 7.35727L252.021 39.2771ZM329.021 75.872L298.426 45.2771L329.021 45.2771L329.021 75.872ZM297.775 39.2771L329.021 39.2771L329.021 8.03071L297.775 39.2771ZM335.021 76.3929L335.021 45.2771H366.137L335.021 76.3929ZM335.021 39.2771H366.289L335.021 8.00925V39.2771ZM412.021 76.524L380.774 45.2771H412.021L412.021 76.524ZM418.021 77.055L418.021 45.2771L449.799 45.2771L418.021 77.055ZM7.28358 335.782L38.5214 367.02V335.782H7.28358ZM44.5214 335.782V366.893L75.6318 335.782L44.5214 335.782ZM75.7846 329.782L44.5214 329.782L44.5214 298.519L75.7846 329.782ZM90.2699 335.782L121.521 367.034V335.782L90.2699 335.782ZM121.521 329.782L90.117 329.782L121.521 298.378V329.782ZM127.521 335.782V367.555L159.294 335.782H127.521ZM158.785 329.782H127.521V298.519L158.785 329.782ZM173.27 335.782L204.521 367.034V335.782H173.27ZM204.521 329.782H173.779L204.521 299.04V329.782ZM210.521 335.782V367.315L242.054 335.782H210.521ZM241.785 329.782H210.521V298.519L241.785 329.782ZM256.27 335.782L287.521 367.034V335.782L256.27 335.782ZM287.521 329.782L256.539 329.782L287.521 298.8L287.521 329.782ZM293.521 335.782L293.521 366.735L324.474 335.782L293.521 335.782ZM324.516 329.782L293.521 329.782L293.521 298.788L324.516 329.782ZM339.001 335.782L370.521 367.303V335.782H339.001ZM370.521 329.782H338.959L370.521 298.22V329.782ZM376.521 335.782L376.521 367.055L407.794 335.782L376.521 335.782ZM408.02 329.782L376.521 329.782L376.521 298.284L408.02 329.782ZM422.505 335.782L453.521 366.799V335.782L422.505 335.782ZM453.521 329.782H422.28L453.521 298.541L453.521 329.782ZM459.521 335.782V367.055L490.794 335.782H459.521ZM490.784 329.782H459.521V298.519L490.784 329.782ZM505.27 335.782L536.521 367.034V335.782L505.27 335.782ZM536.521 329.782L505.28 329.782L536.521 298.541L536.521 329.782ZM542.521 335.782V367.055L573.794 335.782H542.521ZM574.447 329.782H542.521V297.857L574.447 329.782ZM38.5214 329.782H7.26954L38.5214 298.531L38.5214 329.782ZM412.021 256.72L380.459 288.282H412.021V256.72ZM412.021 294.282H381.005L412.021 325.299V294.282ZM335.021 325.235L365.974 294.282L335.021 294.282L335.021 325.235ZM329.021 325.803V294.282H297.501L329.021 325.803ZM298.039 288.282H329.021V257.3L298.039 288.282ZM335.021 256.784L335.021 288.282L366.52 288.282L335.021 256.784ZM252.021 257.288L283.016 288.282H252.021V257.288ZM252.021 294.282H283.554L252.021 325.815V294.282ZM246.021 325.534V294.282H214.77L246.021 325.534ZM215.279 288.282H246.021V257.54L215.279 288.282ZM169.021 257.019L200.285 288.282H169.021V257.019ZM169.021 294.282H200.794L169.021 326.055V294.282ZM163.021 325.534V294.282L131.77 294.282L163.021 325.534ZM131.617 288.282L163.021 288.282V256.878L131.617 288.282ZM86.0214 257.019L117.285 288.282H86.0214V257.019ZM86.0214 294.282H117.132L86.0214 325.393V294.282ZM80.0214 325.534V294.282H48.7698L80.0214 325.534ZM48.7695 288.282H80.0214V257.031L48.7695 288.282ZM418.021 325.555L418.021 294.282L449.294 294.282L418.021 325.555ZM449.284 288.282L418.021 288.282L418.021 257.019L449.284 288.282ZM495.021 257.041L463.78 288.282H495.021L495.021 257.041ZM495.021 294.282H463.77L495.021 325.534L495.021 294.282ZM501.021 325.556V294.282L532.294 294.282L501.021 325.556ZM532.947 288.282L501.021 288.282V256.357L532.947 288.282ZM578.021 257.041L546.78 288.282H578.021L578.021 257.041ZM578.021 294.282H547.432L578.021 324.872V294.282Z",
    fill: "#FDFD56"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_ii_2489_89754)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 290.521,
    cy: 41.5195,
    r: 4.5,
    fill: "#0020EB"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_ii_2489_89754)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 207.521,
    cy: 124.52,
    r: 4.5,
    fill: "#0020EB"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_ii_2489_89754)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 124.521,
    cy: 208.52,
    r: 4.5,
    fill: "#0020EB"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_ii_2489_89754)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 124.521,
    cy: 291.52,
    r: 4.5,
    fill: "#0020EB"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_ii_2489_89754)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "matrix(1 0 0 -1 120.021 379.02)",
    fill: "#0020EB"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_ii_2489_89754)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 290.521,
    cy: 208.52,
    r: 4.5,
    fill: "#0020EB"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_ii_2489_89754)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 290.521,
    cy: 291.52,
    r: 4.5,
    fill: "#0020EB"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_ii_2489_89754)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "matrix(1 0 0 -1 286.021 379.02)",
    fill: "#0020EB"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_ii_2489_89754)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 207.521,
    cy: 41.5195,
    r: 4.5,
    fill: "#0020EB"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_ii_2489_89754)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 124.521,
    cy: 126.52,
    r: 4.5,
    fill: "#0020EB"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_ii_2489_89754)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 124.521,
    cy: 125.52,
    r: 4.5,
    fill: "#0020EB"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter12_ii_2489_89754)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 290.521,
    cy: 124.52,
    r: 4.5,
    fill: "#0020EB"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter13_ii_2489_89754)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 207.521,
    cy: 208.52,
    r: 4.5,
    fill: "#0020EB"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter14_ii_2489_89754)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 207.521,
    cy: 291.52,
    r: 4.5,
    fill: "#0020EB"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter15_ii_2489_89754)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "matrix(1 0 0 -1 203.021 379.02)",
    fill: "#0020EB"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter16_ii_2489_89754)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "matrix(1 0 0 -1 203.021 546.02)",
    fill: "#0020EB"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter17_ii_2489_89754)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "matrix(1 0 0 -1 120.021 462.02)",
    fill: "#0020EB"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter18_ii_2489_89754)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 373.521,
    cy: 124.52,
    r: 4.5,
    fill: "#0020EB"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter19_ii_2489_89754)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "matrix(1 0 0 -1 369.021 546.02)",
    fill: "#0020EB"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter20_ii_2489_89754)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "matrix(1 0 0 -1 286.021 462.02)",
    fill: "#0020EB"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter21_ii_2489_89754)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 456.521,
    cy: 208.52,
    r: 4.5,
    fill: "#0020EB"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter22_ii_2489_89754)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "matrix(1 0 0 -1 452.021 462.02)",
    fill: "#0020EB"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter23_ii_2489_89754)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 456.521,
    cy: 291.52,
    r: 4.5,
    fill: "#0020EB"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter24_ii_2489_89754)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "matrix(1 0 0 -1 452.021 379.02)",
    fill: "#0020EB"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter25_ii_2489_89754)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 41.5215,
    cy: 208.52,
    r: 4.5,
    fill: "#0020EB"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter26_ii_2489_89754)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 41.5215,
    cy: 291.52,
    r: 4.5,
    fill: "#0020EB"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter27_ii_2489_89754)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "matrix(1 0 0 -1 37.0215 379.02)",
    fill: "#0020EB"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter28_ii_2489_89754)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 373.521,
    cy: 41.5195,
    r: 4.5,
    fill: "#0020EB"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter29_ii_2489_89754)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "matrix(1 0 0 -1 286.021 546.02)",
    fill: "#0020EB"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter30_ii_2489_89754)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "matrix(1 0 0 -1 203.021 462.02)",
    fill: "#0020EB"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter31_ii_2489_89754)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 456.521,
    cy: 124.52,
    r: 4.5,
    fill: "#0020EB"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter32_ii_2489_89754)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "matrix(1 0 0 -1 452.021 546.02)",
    fill: "#0020EB"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter33_ii_2489_89754)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 373.521,
    cy: 208.52,
    r: 4.5,
    fill: "#0020EB"
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter34_ii_2489_89754)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "matrix(1 0 0 -1 369.021 462.02)",
    fill: "#0020EB"
  }))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter35_ii_2489_89754)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 539.521,
    cy: 208.52,
    r: 4.5,
    fill: "#0020EB"
  }))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter36_ii_2489_89754)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "matrix(1 0 0 -1 535.021 462.02)",
    fill: "#0020EB"
  }))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter37_ii_2489_89754)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 373.521,
    cy: 291.52,
    r: 4.5,
    fill: "#0020EB"
  }))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter38_ii_2489_89754)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "matrix(1 0 0 -1 369.021 379.02)",
    fill: "#0020EB"
  }))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter39_ii_2489_89754)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 539.521,
    cy: 291.52,
    r: 4.5,
    fill: "#0020EB"
  }))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter40_ii_2489_89754)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "matrix(1 0 0 -1 535.021 379.02)",
    fill: "#0020EB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_di_2489_89754",
    x: 0.0336914,
    y: 0.0390625,
    width: 593.975,
    height: 594.961,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2489_89754"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2489_89754",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2489_89754"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_ii_2489_89754",
    x: 286.021,
    y: 37.0195,
    width: 9,
    height: 9,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2489_89754"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_2489_89754",
    result: "effect2_innerShadow_2489_89754"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_ii_2489_89754",
    x: 203.021,
    y: 120.02,
    width: 9,
    height: 9,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2489_89754"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_2489_89754",
    result: "effect2_innerShadow_2489_89754"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_ii_2489_89754",
    x: 120.021,
    y: 204.02,
    width: 9,
    height: 9,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2489_89754"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_2489_89754",
    result: "effect2_innerShadow_2489_89754"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_ii_2489_89754",
    x: 120.021,
    y: 287.02,
    width: 9,
    height: 9,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2489_89754"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_2489_89754",
    result: "effect2_innerShadow_2489_89754"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_ii_2489_89754",
    x: 120.021,
    y: 370.02,
    width: 9,
    height: 9,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2489_89754"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_2489_89754",
    result: "effect2_innerShadow_2489_89754"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_ii_2489_89754",
    x: 286.021,
    y: 204.02,
    width: 9,
    height: 9,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2489_89754"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_2489_89754",
    result: "effect2_innerShadow_2489_89754"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_ii_2489_89754",
    x: 286.021,
    y: 287.02,
    width: 9,
    height: 9,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2489_89754"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_2489_89754",
    result: "effect2_innerShadow_2489_89754"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_ii_2489_89754",
    x: 286.021,
    y: 370.02,
    width: 9,
    height: 9,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2489_89754"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_2489_89754",
    result: "effect2_innerShadow_2489_89754"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_ii_2489_89754",
    x: 203.021,
    y: 37.0195,
    width: 9,
    height: 9,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2489_89754"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_2489_89754",
    result: "effect2_innerShadow_2489_89754"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_ii_2489_89754",
    x: 120.021,
    y: 122.02,
    width: 9,
    height: 9,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2489_89754"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_2489_89754",
    result: "effect2_innerShadow_2489_89754"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_ii_2489_89754",
    x: 120.021,
    y: 121.02,
    width: 9,
    height: 9,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2489_89754"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_2489_89754",
    result: "effect2_innerShadow_2489_89754"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_ii_2489_89754",
    x: 286.021,
    y: 120.02,
    width: 9,
    height: 9,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2489_89754"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_2489_89754",
    result: "effect2_innerShadow_2489_89754"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_ii_2489_89754",
    x: 203.021,
    y: 204.02,
    width: 9,
    height: 9,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2489_89754"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_2489_89754",
    result: "effect2_innerShadow_2489_89754"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter14_ii_2489_89754",
    x: 203.021,
    y: 287.02,
    width: 9,
    height: 9,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2489_89754"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_2489_89754",
    result: "effect2_innerShadow_2489_89754"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter15_ii_2489_89754",
    x: 203.021,
    y: 370.02,
    width: 9,
    height: 9,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2489_89754"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_2489_89754",
    result: "effect2_innerShadow_2489_89754"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter16_ii_2489_89754",
    x: 203.021,
    y: 537.02,
    width: 9,
    height: 9,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2489_89754"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_2489_89754",
    result: "effect2_innerShadow_2489_89754"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter17_ii_2489_89754",
    x: 120.021,
    y: 453.02,
    width: 9,
    height: 9,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2489_89754"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_2489_89754",
    result: "effect2_innerShadow_2489_89754"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter18_ii_2489_89754",
    x: 369.021,
    y: 120.02,
    width: 9,
    height: 9,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2489_89754"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_2489_89754",
    result: "effect2_innerShadow_2489_89754"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter19_ii_2489_89754",
    x: 369.021,
    y: 537.02,
    width: 9,
    height: 9,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2489_89754"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_2489_89754",
    result: "effect2_innerShadow_2489_89754"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter20_ii_2489_89754",
    x: 286.021,
    y: 453.02,
    width: 9,
    height: 9,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2489_89754"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_2489_89754",
    result: "effect2_innerShadow_2489_89754"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter21_ii_2489_89754",
    x: 452.021,
    y: 204.02,
    width: 9,
    height: 9,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2489_89754"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_2489_89754",
    result: "effect2_innerShadow_2489_89754"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter22_ii_2489_89754",
    x: 452.021,
    y: 453.02,
    width: 9,
    height: 9,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2489_89754"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_2489_89754",
    result: "effect2_innerShadow_2489_89754"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter23_ii_2489_89754",
    x: 452.021,
    y: 287.02,
    width: 9,
    height: 9,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2489_89754"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_2489_89754",
    result: "effect2_innerShadow_2489_89754"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter24_ii_2489_89754",
    x: 452.021,
    y: 370.02,
    width: 9,
    height: 9,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2489_89754"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_2489_89754",
    result: "effect2_innerShadow_2489_89754"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter25_ii_2489_89754",
    x: 37.0215,
    y: 204.02,
    width: 9,
    height: 9,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2489_89754"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_2489_89754",
    result: "effect2_innerShadow_2489_89754"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter26_ii_2489_89754",
    x: 37.0215,
    y: 287.02,
    width: 9,
    height: 9,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2489_89754"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_2489_89754",
    result: "effect2_innerShadow_2489_89754"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter27_ii_2489_89754",
    x: 37.0215,
    y: 370.02,
    width: 9,
    height: 9,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2489_89754"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_2489_89754",
    result: "effect2_innerShadow_2489_89754"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter28_ii_2489_89754",
    x: 369.021,
    y: 37.0195,
    width: 9,
    height: 9,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2489_89754"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_2489_89754",
    result: "effect2_innerShadow_2489_89754"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter29_ii_2489_89754",
    x: 286.021,
    y: 537.02,
    width: 9,
    height: 9,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2489_89754"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_2489_89754",
    result: "effect2_innerShadow_2489_89754"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter30_ii_2489_89754",
    x: 203.021,
    y: 453.02,
    width: 9,
    height: 9,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2489_89754"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_2489_89754",
    result: "effect2_innerShadow_2489_89754"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter31_ii_2489_89754",
    x: 452.021,
    y: 120.02,
    width: 9,
    height: 9,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2489_89754"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_2489_89754",
    result: "effect2_innerShadow_2489_89754"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter32_ii_2489_89754",
    x: 452.021,
    y: 537.02,
    width: 9,
    height: 9,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2489_89754"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_2489_89754",
    result: "effect2_innerShadow_2489_89754"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter33_ii_2489_89754",
    x: 369.021,
    y: 204.02,
    width: 9,
    height: 9,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2489_89754"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_2489_89754",
    result: "effect2_innerShadow_2489_89754"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter34_ii_2489_89754",
    x: 369.021,
    y: 453.02,
    width: 9,
    height: 9,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2489_89754"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_2489_89754",
    result: "effect2_innerShadow_2489_89754"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter35_ii_2489_89754",
    x: 535.021,
    y: 204.02,
    width: 9,
    height: 9,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2489_89754"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_2489_89754",
    result: "effect2_innerShadow_2489_89754"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter36_ii_2489_89754",
    x: 535.021,
    y: 453.02,
    width: 9,
    height: 9,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2489_89754"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_2489_89754",
    result: "effect2_innerShadow_2489_89754"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter37_ii_2489_89754",
    x: 369.021,
    y: 287.02,
    width: 9,
    height: 9,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2489_89754"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_2489_89754",
    result: "effect2_innerShadow_2489_89754"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter38_ii_2489_89754",
    x: 369.021,
    y: 370.02,
    width: 9,
    height: 9,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2489_89754"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_2489_89754",
    result: "effect2_innerShadow_2489_89754"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter39_ii_2489_89754",
    x: 535.021,
    y: 287.02,
    width: 9,
    height: 9,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2489_89754"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_2489_89754",
    result: "effect2_innerShadow_2489_89754"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter40_ii_2489_89754",
    x: 535.021,
    y: 370.02,
    width: 9,
    height: 9,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2489_89754"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_2489_89754",
    result: "effect2_innerShadow_2489_89754"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowMask);
export default __webpack_public_path__ + "static/media/YellowMask.0314fa57af2f252e51ec7ad2a5dd8d26.svg";
export { ForwardRef as ReactComponent };